export const authenticationActivityTypesMap = {
  AuthSuccess: 1,
  AuthFailure: 2,
  Logout: 3,
};

export const authenticationActivityTypesLabels = {
  [authenticationActivityTypesMap.AuthSuccess]: 'Успешный вход',
  [authenticationActivityTypesMap.AuthFailure]: 'Неуспешная попытка входа',
  [authenticationActivityTypesMap.Logout]: 'Выход',
};
